import styled from "@emotion/styled";
import {Text} from '@nike/eds';

const StyledDiv = styled.div`
  margin: 3em auto;
  width: 90%;
`;

export default function PDP() {
    return (
        <StyledDiv id="pdp-thread-page">
            <Text font={"title-1"}>
                Coming soon
            </Text>
        </StyledDiv>
    );
}
